import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ProfileManufacturerAgreementDto} from "../../shipper";
import {NgForOf} from "@angular/common";


@Component({
	selector: 'terms-agreement',
	standalone: true,
	templateUrl: 'terms.agreement.html',
	imports: [
		NgForOf
	],
	styles: [`
        li > div.title {
            font-weight: bold;
        }

        .list-group-flush li {
            font-style: italic;
        }

        .card-body {
            /*
			max-height: 450px;
			
			overflow-y: scroll;
			
			 */
        }

        .modal-footer {
            display: block;
        }
	`]
})
export class TermsAgreement implements OnInit{
	
	
	@Output()
	onYes:EventEmitter<Array<ProfileManufacturerAgreementDto>> = new EventEmitter();
	
	@Output()
	onNo:EventEmitter<void> = new EventEmitter();
	
	@Input()
	agreements:Array<ProfileManufacturerAgreementDto> = [];
	
	
	constructor(public modal:NgbActiveModal) {}
	
	
	ngOnInit(): void {}

	
	agree(){
		this.onYes.emit(this.agreements);
	}
	
	
	disagree(){
		this.onNo.emit();
	}
}
